export interface AuthErrorAlertProps {
	message: string | string[] | null
	variant?: 'error' | 'success'
}

export function AuthErrorAlert({ message, variant = 'error' }: AuthErrorAlertProps) {
	if (!message || (Array.isArray(message) && message.length === 0)) {
		return null
	}

	const styles = {
		error: 'bg-red-50 border-red-200 text-red-700',
		success: 'bg-green-50 border-green-200 text-green-700',
	}

	const messages = Array.isArray(message) ? message : [message]

	return (
		<div className={`p-3 rounded-lg border text-sm ${styles[variant]}`}>
			{messages.length === 1
				? (
					messages[0]
				)
				: (
					<ul className="list-disc pl-4 space-y-1">
						{messages.map((msg, index) => <li key={index}>{msg}</li>)}
					</ul>
				)}
		</div>
	)
}
